module.exports = __webpack_public_path__ + "static/media/CanolaGreen.749aba70.svg";